import { Link } from "react-router-dom";
import { ArrowRight, BookOpen, Heart, Youtube } from "lucide-react";
import { Reveal, Overline } from "./Reveal";

const CARDS = [
  {
    id: "terrain-and-truth",
    icon: Youtube,
    overline: "The Podcast",
    title: "Terrain and Truth",
    copy: "Watch and read Staci's podcast episodes, conversations, and educational posts.",
    cta: "Explore the Podcast",
    to: "/terrain-and-truth",
  },
  {
    id: "the-detox-gospel",
    icon: BookOpen,
    overline: "Free Ebook",
    title: "Discover The Detox Gospel",
    copy: "Explore Staci's ebook and receive your free copy.",
    cta: "Get the Free Ebook",
    to: "/the-detox-gospel",
  },
  {
    id: "favorites",
    icon: Heart,
    overline: "Staci's Favorites",
    title: "Resources I Love",
    copy: "Discover books, tools, and products personally recommended by Staci.",
    cta: "Explore My Favorites",
    to: "/favorites",
  },
];

export const ResourcesPromo = () => (
  <section data-testid="resources-promo" className="mx-auto max-w-6xl px-5 py-20 sm:px-8 sm:py-24">
    <Reveal className="text-center">
      <Overline>Keep Exploring</Overline>
      <h2 className="mt-4 font-serif text-3xl leading-tight text-forest sm:text-4xl">
        Learn, read, and gather <em className="italic text-gold">what serves you</em>
      </h2>
    </Reveal>
    <div className="mt-12 grid grid-cols-1 gap-6 md:grid-cols-3">
      {CARDS.map((c, i) => (
        <Reveal key={c.id} delay={i * 0.08}>
          <Link
            to={c.to}
            data-testid={`promo-${c.id}`}
            className="group flex h-full flex-col rounded-[2rem] border border-forest/10 bg-white/75 p-8 shadow-[0_14px_35px_rgba(23,63,53,0.08)] transition-all duration-500 hover:-translate-y-1.5 hover:border-gold/40 hover:shadow-[0_24px_55px_rgba(23,63,53,0.14)]"
          >
            <span className="flex h-12 w-12 items-center justify-center rounded-full bg-sage transition-colors duration-300 group-hover:bg-gold/20">
              <c.icon className="h-5 w-5 text-forest" />
            </span>
            <p className="mt-5 text-xs font-semibold uppercase tracking-[0.2em] text-gold">
              {c.overline}
            </p>
            <h3 className="mt-2 font-serif text-2xl leading-snug text-forest">{c.title}</h3>
            <p className="mt-3 flex-1 text-sm leading-relaxed text-charcoal/70">{c.copy}</p>
            <span className="mt-6 inline-flex items-center gap-2 text-sm font-semibold text-forest transition-colors group-hover:text-gold-dark">
              {c.cta}
              <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
            </span>
          </Link>
        </Reveal>
      ))}
    </div>
  </section>
);
